export enum ChannelEnum {
    LINK = 'LINK',
    QRCODE = 'QRCODE',
}

export enum ChannelLabelEnum {
    LINK = 'Compartilhamento de Link',
    QRCODE = 'QR Code',
}
